import { Question, Answers } from './questions';

function findFirstUnansweredIndex(survey: Question[], userAnswers: Answers) {
  let lastQuestionIndex = 0;
  let found = false;
  for (let i = 0; i < survey.length && !found; i++) {
    const question = survey[i];
    if (!userAnswers[question.code]) {
      lastQuestionIndex = i;
      found = true;
    }
  }

  return lastQuestionIndex;
}

export default findFirstUnansweredIndex;
